import * as types from '../constants/ActionTypes';


const INITIAL_STATE = {
    canReply: undefined,
    error: null,
    latestMessages: [],
    latestMessageId: 0,
};

export default function messagesReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.LIMITED_LOGIN_SEND_MESSAGE_SUCCESS:
            return {
                ...state,
                error: null,
                ...action,
            };

        case types.LIMITED_LOGIN_SEND_MESSAGE_ERROR:
            return {
                ...state,
                error: action,
            };

        // Return error: null ensures the UI is updated should an error occur in between successful requests.
        case types.GET_MESSAGES_SUCCESS:
            return {
                ...state,
                canReply: action.response.canReply,
                error: null,
                latestMessages: action.response.messagesList,
                latestMessageId: action.response.latestMessageId,
            };

        case types.REPLY_TO_CONVERSATION_SUCCESS:
            return {
                ...state,
                error: null,
            };

        case types.SWITCH_CONVERSATION_SUCCESS:
            return {
                ...state,
                error: null,
                latestMessages: INITIAL_STATE.latestMessages,
            };

        case types.REPLY_ERROR:
            console.error(types.REPLY_ERROR, action);
            return {
                ...state,
                error: {
                    type: action.type,
                    status: action.response.status,
                    data: action.response.data,
                },
            };

        case types.CONVERSATION_ERROR:
            console.error(types.CONVERSATION_ERROR, action);
            return {
                ...state,
                error: {
                    type: action.type,
                    status: action.response.status,
                    data: action.response.data,
                },
            };

        default:
            return state;
    }
}
